import { BooleanInput, Edit, ImageField, ImageInput, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { CountryInput, RichText } from '../sessions/fields';
import { ConfsForSpeaker } from './ConfsForSpeaker';

export const SpeakerEdit = () => (
  <Edit title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="firstname" />
      <TextInput source="lastname" />
      <CountryInput />
      <RichText source="cv" />
      <ImageInput source="avatar" label="avatar" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
      <BooleanInput source="isRockStar" />
      <ConfsForSpeaker />
    </SimpleForm>
  </Edit>
);
